import Vue from 'vue'
import Vuex from 'vuex'
import app from './vuex/app'
import auth from './vuex/auth'
import site from './vuex/site'
import referential from './vuex/referential'
import breadcrumb from './vuex/breadcrumb'
import customerConfig from './vuex/customerConfig'
import userPreferences from './vuex/userPreferences'
import alerts from './vuex/alerts'
import areaSidebar from './vuex/areaSidebar'
import dataQuality from './vuex/dataQuality'

const debug = process.env.NODE_ENV !== 'production'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    auth,
    site,
    referential,
    breadcrumb,
    customerConfig,
    userPreferences,
    alerts,
    areaSidebar,
    dataQuality,
  },
  strict: debug,
})
